export default "__VITE_ASSET__ed8bb47a__"